import api from '../../../api/index';
import apiShopkeeperApp from '../../../api/shopkeeperAppApi';

export default {
  showClient({ rootGetters }, value) {
    return api.post('/quote/show-user', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  showPlanosApp({ rootGetters }) {
    return api.get('/todos-planos-app', {
    });
  },
  showPlanosAppId({ rootGetters }, id) {
    return api.get(`/todos-planos-app/${id}`, {
    });
  },
  showPlanosAppLojistaId({ rootGetters }, id) {
    return api.get(`/todos-planos-app-lojista/${id}`, {
    });
  },
  showPlanosAppLojista({ rootGetters }) {
    return api.get('/todos-planos-app-lojista', {
    });
  },
  showPlanosProfissional({ rootGetters }, id) {
    return api.get('/todos-planos-profissional-site/'+id, {
    });
  },
  showPlanosProfissionalPlanoId({ rootGetters }, id) {
    return api.get(`/todos-planos-app/${id}`, {
    });
  },
  showPlanosProfissionalId({ rootGetters }, id) {
    return api.get(`/todos-planos-app-lojista/${id}`, {
    });
  },
  showPlanosProfissionalAll({ rootGetters }) {
    return api.get('/todos-planos-app-lojista', {
    });
  },
  getDadosAssinatura({ rootGetters }, data) {
    return api.post('admin/dados-assinatura-lojista', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getDadosFacebookAds({ rootGetters }, id) {
    return api.get(`admin/dados-facebook-ads/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  saveDadosFacebookAds({ rootGetters }, data) {
    return api.post('admin/save-dados-facebook-ads', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  udpateStatusAgentIa({ rootGetters }, data) {
    return api.post('app/lojista/update-agent-ia', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  atualizarDadosAssinatura({ rootGetters }, data) {
    return api.post('admin/atualizar-assinatura-lojista', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  bucarProdutoEditar({}, busca) {
    return apiShopkeeperApp.get(`/bucar-produto-editar?busca=${busca}`, {
    });
  },
  removerProdutoLista({}, id) {
    return apiShopkeeperApp.get(`/remover-produto-lista/${id}`, {
    });
  },
  bucarProdutoEditarLojista({}, {id, currentPage = 1}) {
    return apiShopkeeperApp.get(`/bucar-produto-editar-lojista?page=${currentPage || ''}&id=${id}`, {
    });
  },
  bucarNovoProduto({}) {
    return apiShopkeeperApp.get('/bucar-produto-aprovacao', {
    });
  },
  bucarNovoProdutoLojista({}, id) {
    return apiShopkeeperApp.get('/bucar-produto-aprovacao-lojista/'+id, {
    });
  },
  buscarLojinstaId({}, id) {
    return api.get('/app/shopkeeper/'+id, {
    });
  },
  bucarNovoUpStatus({}, data) {
    return apiShopkeeperApp.post('/produto-aprovacao-up-status', data, {
    });
  },
  addProdutosExcel({}, data) {
    return apiShopkeeperApp.post('/products/adicionar-produtos-excel', data, {
    });
  },
  addProdutosExcelIa({}, data) {
    return apiShopkeeperApp.post('/inserir-produtos-excel-ia', data, {
    });
  },
  addClientesExcel({}, data) {
    return apiShopkeeperApp.post('/client/add-clients-xlsx', data, {
    });
  },
  sendWhatsappExcel({}, data) {
    return api.post('/enviar-whatsapp-excel', data, {
    });
  },
  sendWhatsappAudio({}, data) {
    return api.post('/enviar-whatsapp-audio', data, {
    });
  },
  bucarNovoUpStatusRequest({}, data) {
    return apiShopkeeperApp.post('/produto-aprovacao-up-status-request', data, {
    });
  },
  novoPlanoApp({ rootGetters }, data) {
    return api.post('/admin/novo-plano-app', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  alterarPlanoApp({ rootGetters }, data) {
    return api.post('/admin/alterar-plano-app', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  inativarPlanoApp({ rootGetters }, id) {
    return api.get(`/admin/inativar-plano-app/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  excluirPlanoApp({ rootGetters }, data) {
    return api.get(`/admin/excluir-plano-app/${data.id}/${data.iugu_subaccount_id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  novoPlanoProfissional({ rootGetters }, data) {
    return api.post('/admin/novo-plano-profissional', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  alterarPlanoProfissional({ rootGetters }, data) {
    return api.post('/admin/alterar-plano-profissional', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  inativarPlanoProfissional({ rootGetters }, id) {
    return api.get(`/admin/inativar-plano-profissional/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  excluirPlanoProfissional({ rootGetters }, id) {
    return api.get(`/admin/excluir-plano-profissional/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  novoPlano({ rootGetters }, data) {
    return api.post('/admin/novo-plano', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  alterarPlano({ rootGetters }, data) {
    return api.post('/admin/alterar-plano', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  inativarPlano({ rootGetters }, id) {
    return api.get(`/admin/inativar-plano/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getConstrupWhatsApp({ rootGetters }) {
    return api.get(`/admin/buscar-construbots`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  upConstrupWhatsApp({ rootGetters }, id) {
    return api.get(`/admin/atualizar-status-construbots/${id}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAffiliatePendingBillets({ rootGetters, commit }) {
    return api
      .get('/admin/affiliate/pending-billets', {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      })
      .then((response) => {
        commit('setPendingBillets', response.data.data);
      });
  },
  getAffiliatePendingBilletInformation({ rootGetters, commit }, ids) {
    return api
      .get(
        `/admin/affiliate/pending-billets/${ids.pendingBilletId}/${ids.affiliateId}/${ids.shopkeeperId}`,
        {
          headers: {
            Authorization: `Bearer ${rootGetters.getToken}`,
          },
        }
      )
      .then((response) => {
        commit('setPendingBilletInformation', response.data);
      });
  },
  changeBilletStatus({ rootGetters }, data) {
    return api.put(
      `/admin/affiliate/billet-status/${data.pendingBilletId}/${data.newStatus}/`,
      null,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getCities({ rootGetters, commit }) {
    return api
      .get('/admin/cities', {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      })
      .then((response) => {
        commit('setCities', response.data.data);
      });
  },
  buscarVersion({ rootGetters }) {
    return apiShopkeeperApp.get('/app-version', {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
  },
  searchProductsPhotos({}, data) {
    return apiShopkeeperApp.get(
      `/list-products-photos?start=${data.start}&end=${data.end}&codbar=${data.codbar}&shopkeeperId=${data.shopkeeperId}&categoryId=${data.categoryId}`
    );
  },
  saveProductOrder({}, data) {
    return apiShopkeeperApp.post('/save-product-order', data);
  },
  deleteProductPhoto({}, id) {
    return apiShopkeeperApp.delete(`/delete-product-photo/${id}`);
  },
  saveVersion({ rootGetters }, data ) {
    return apiShopkeeperApp.post('/app-version-up', data, {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      });
  },
  getSegments({ rootGetters, commit }) {
    return api
      .get('/segmentos-all', {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      })
      .then((response) => {
        commit('setSegments', response.data.data);
      });
  },
  toggleCityStatus({ rootGetters }, cityId) {
    return api.put(`/admin/cities/${cityId}/status`, null, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  setRankingDate({ rootGetters }, range) {
    return api.post(
      `admin/partner/set-ranking-date?from=${range ? range.from : ''}&to=${
        range ? range.to : ''
      }`,
      null,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  setExternalRankingDate({ rootGetters }, range) {
    return api.post(
      `admin/partner/set-external-ranking-date?from=${
        range ? range.from : ''
      }&to=${range ? range.to : ''}`,
      null,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getShopkeeperWithApps({ rootGetters }) {
    return api.get('/shopkeeper/with-app', {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getOrdersStatusSummary(
    { rootGetters },
    { shopkeepersIds, clerkId, startDate, endDate }
  ) {
    let queryParams = `?clerkId=${clerkId || ''}`;
    queryParams += `&startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;
    queryParams += `&shopkeepersIds=${shopkeepersIds || ''}`;

    return apiShopkeeperApp.get(`/app/orders/status-summary${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getOrdersSummary(
    { rootGetters },
    {
      shopkeepersIds,
      clerkId,
      clientName,
      orderNumber,
      startDate,
      endDate,
      status,
      currentPage = 1,
    }
  ) {
    let queryParams = `?shopkeepersIds=${shopkeepersIds || ''}`;
    queryParams += `&clerkId=${clerkId || ''}`;
    queryParams += `&page=${currentPage || 1}`;
    queryParams += `&clientName=${clientName || ''}`;
    queryParams += `&orderNumber=${orderNumber || ''}`;
    queryParams += `&startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;
    queryParams += `&status=${status || ''}`;

    return apiShopkeeperApp.get(`/app/orders/summary${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getSelectedProductsGeneral(
    { rootGetters },
    { shopkeepersIds, productName, familyId, currentPage = 1 }
  ) {
    let queryParams = `?shopkeepersIds=${shopkeepersIds || ''}`;
    queryParams += `&page=${currentPage || ''}`;
    queryParams += `&productName=${productName || ''}`;
    queryParams += `&familyId=${familyId || 0}`;

    return apiShopkeeperApp.get(`/products/selected/general${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getAllSpreadsheetsToImport(
    { rootGetters },
    { shopkeepersIds, startDate, endDate, status, currentPage = 1 }
  ) {
    let queryParams = `?shopkeepersIds=${shopkeepersIds || ''}`;
    queryParams += `&page=${currentPage || 1}`;
    queryParams += `&startDate=${startDate || ''}`;
    queryParams += `&endDate=${endDate || ''}`;
    queryParams += `&status=${status || ''}`;

    return apiShopkeeperApp.get(`/products/spreadsheet-to-import${queryParams}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  showDataShopkeeperApp({ rootGetters }, shopkeepers) {
    return api.post('/lojistas-dados', shopkeepers, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  addGerenteConta({ rootGetters }, data) {
    return api.post('admin/add-gerente-conta', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  updateGerenteConta({ rootGetters }, data) {
    return api.post('admin/update-gerente-conta', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  vincularGerenteConta({ rootGetters }, data) {
    return api.post('admin/vincular-gerente-conta', data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  upStatusGerente({ rootGetters }, id) {
    return api.get('admin/status-gerente-conta/'+id, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },

  getGerenteConta({ rootGetters }, data) {
    return api.get(`admin/get-gerente-conta?startDate=${data.startDate}&endDate=${data.endDate}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
};
